import { allTrackers } from "app/services/track/track";

import createOnboardingWizardTrackingService from "./factory";

const onboardingWizardTrackingService = createOnboardingWizardTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default onboardingWizardTrackingService;
